// sidebar
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

// loading
export const LOADING = 'LOADING';
export const UNLOADING = 'UNLOADING';

// error
export const CLEAR_ERROR_FLG = 'CLEAR_ERROR_FLG';
export const ACCESS_DENIED = 'ACCESS_DENIED';

// result
export const REQUEST_SUCCESS = 'REQUEST_SUCCESS';
export const REQUEST_FAILURE = 'REQUEST_FAILURE';
export const CLEAR_RESULT_FLG = 'CLEAR_RESULT_FLG';

// auth
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const REFRESH_TOKEN_LOGIN_SUCCESS = 'REFRESH_TOKEN_LOGIN_SUCCESS';
export const REFRESH_TOKEN_LOGIN_FAILURE = 'REFRESH_TOKEN_LOGIN_FAILURE';
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS';
export const UPDATE_PASSWORD_FAILURE = 'UPDATE_PASSWORD_FAILURE';
export const CLEAR_UPDATE_PASSWORD_RESULT_FLG = 'CLEAR_UPDATE_PASSWORD_RESULT_FLG';
export const UPDATE_SETTINGS_SUCCESS = 'UPDATE_SETTINGS_SUCCESS';
export const UPDATE_SETTINGS_FAILURE = 'UPDATE_SETTINGS_FAILURE';
export const UPDATE_SETTING_EMAIL_SUCCESS = 'UPDATE_SETTING_EMAIL_SUCCESS';
export const UPDATE_SETTING_EMAIL_FAILURE = 'UPDATE_SETTING_EMAIL_FAILURE';
export const CLEAR_UPDATE_SETTINGS_RESULT_FLG = 'CLEAR_UPDATE_SETTINGS_RESULT_FLG';
export const LOGOUT = 'LOGOUT';
export const UPDATE_LOGO_SEAL_SUCCESS = 'UPDATE_LOGO_SEAL_SUCCESS';
export const UPDATE_LOGO_SEAL_FAILURE = 'UPDATE_LOGO_SEAL_FAILURE';

// transaction
export const GET_TRANSACTION_LIST_SUCCESS = 'GET_TRANSACTION_LIST_SUCCESS';
export const GET_TRANSACTION_LIST_FAILURE = 'GET_TRANSACTION_LIST_FAILURE';
export const GET_ALL_TRANSACTION_LIST_SUCCESS = 'GET_ALL_TRANSACTION_LIST_SUCCESS';
export const GET_ALL_TRANSACTION_LIST_FAILURE = 'GET_ALL_TRANSACTION_LIST_FAILURE';
export const GET_TRANSACTION_LIST_BY_SALESPERSON_SUCCESS = 'GET_TRANSACTION_LIST_BY_SALESPERSON_SUCCESS';
export const GET_TRANSACTION_LIST_BY_SALESPERSON_FAILURE = 'GET_TRANSACTION_LIST_BY_SALESPERSON_FAILURE';
export const GET_ALL_TRANSACTION_LIST_BY_SALESPERSON_SUCCESS = 'GET_ALL_TRANSACTION_LIST_BY_SALESPERSON_SUCCESS';
export const GET_ALL_TRANSACTION_LIST_BY_SALESPERSON_FAILURE = 'GET_ALL_TRANSACTION_LIST_BY_SALESPERSON_FAILURE';
export const GET_TRANSACTION_LIST_BY_CUSTOMER_SUCCESS = 'GET_TRANSACTION_LIST_BY_CUSTOMER_SUCCESS';
export const GET_TRANSACTION_LIST_BY_CUSTOEMR_FAILURE = 'GET_TRANSACTION_LIST_BY_CUSTOEMR_FAILURE';
export const GET_COUNT_TRANSACTION_LIST_BY_SALESPERSON_SUCCESS = 'GET_COUNT_TRANSACTION_LIST_BY_SALESPERSON_SUCCESS';
export const GET_COUNT_TRANSACTION_LIST_BY_SALESPERSON_FAILURE = 'GET_COUNT_TRANSACTION_LIST_BY_SALESPERSON_FAILURE';
export const GET_CSV_TRANSACTION_LIST_NEW_SUCCESS = 'GET_CSV_TRANSACTION_LIST_NEW_SUCCESS';
export const GET_CSV_TRANSACTION_LIST_NEW_FAILURE = 'GET_CSV_TRANSACTION_LIST_NEW_FAILURE';
export const GET_TRANSACTION_DETAIL_SUCCESS = 'GET_TRANSACTION_DETAIL_SUCCESS';
export const GET_TRANSACTION_DETAIL_FAILURE = 'GET_TRANSACTION_DETAIL_FAILURE';
export const GET_TRANSACTION_COUNT_SUCCESS = 'GET_TRANSACTION_COUNT_SUCCESS';
export const GET_TRANSACTION_COUNT_FAILURE = 'GET_TRANSACTION_COUNT_FAILURE';
export const SBP_REFUND_SUCCESS = 'SBP_REFUND_SUCCESS';
export const SBP_REFUND_FAILURE = 'SBP_REFUND_FAILURE';
export const UPC_REFUND_SUCCESS = 'UPC_REFUND_SUCCESS';
export const UPC_REFUND_FAILURE = 'UPC_REFUND_FAILURE';
export const SBP_REFUND_PAYPAY_SUCCESS = 'SBP_REFUND_PAYPAY_SUCCESS';
export const SBP_REFUND_PAYPAY_FAILURE = 'SBP_REFUND_PAYPAY_FAILURE';
export const CLEAR_REFUND_RESULT_FLG = 'CLEAR_REFUND_RESULT_FLG';
export const SET_TRANSACTION_QUERY = 'SET_TRANSACTION_QUERY';
export const CLEAR_TRANSACTION_QUERY = 'CLEAR_TRANSACTION_QUERY';
export const GET_RECEIPT_SUCCESS = 'GET_RECEIPT_SUCCESS';
export const GET_RECEIPT_FAILURE = 'GET_RECEIPT_FAILURE';
export const CLEAR_RECEIPT = 'CLEAR_RECEIPT';
export const UPDATE_STATUS_REFUND_SUCCESS = 'UPDATE_STATUS_REFUND_SUCCESS';
export const GET_DATA_TRANSACTION_WITH_SALESPERSON_SUCCESS = 'GET_DATA_TRANSACTION_WITH_SALESPERSON_SUCCESS';
export const GET_DATA_TRANSACTION_WITH_SALESPERSON_FAILURE = 'GET_DATA_TRANSACTION_WITH_SALESPERSON_FAILURE';
export const UPDATE_STATUS_CSTORE_SUCCESS = 'UPDATE_STATUS_CSTORE_SUCCESS';
export const GET_TRANSACTION_STATUS_CSV_LIST_SUCCESS = 'GET_TRANSACTION_STATUS_CSV_LIST_SUCCESS';
export const GET_TRANSACTION_STATUS_CSV_LIST_FAILURE = 'GET_TRANSACTION_STATUS_CSV_LIST_FAILURE';
export const SET_TRANSACTION_STATUS_CSV_QUERY = 'SET_TRANSACTION_STATUS_CSV_QUERY';

// subscription
export const GET_SUBSCRIPTION_DETAIL_SUCCESS = 'GET_SUBSCRIPTION_DETAIL_SUCCESS';
export const GET_SUBSCRIPTION_DETAIL_FAILURE = 'GET_SUBSCRIPTION_DETAIL_FAILURE';
export const GET_SUBSCRIPTION_LIST_SUCCESS = 'GET_SUBSCRIPTION_LIST_SUCCESS';
export const GET_SUBSCRIPTION_LIST_FAILURE = 'GET_SUBSCRIPTION_LIST_FAILURE';
export const SET_SUBSCRIPTION_QUERY = 'SET_SUBSCRIPTION_QUERY';

export const CLEAR_REJECT_SUBSCRIPTION_RESULT_FLG = 'CLEAR_REJECT_SUBSCRIPTION_RESULT_FLG';

// processing
export const UPLOAD_CSV_SUCCESS = 'UPLOAD_CSV_SUCCESS';
export const UPLOAD_CSV_FAILURE = 'UPLOAD_CSV_FAILURE';
export const UPLOAD_TRANSFER_ACCOUNT_SUCCESS = 'UPLOAD_TRANSFER_ACCOUNT_SUCCESS';
export const UPLOAD_TRANSFER_ACCOUNT_FAILURE = 'UPLOAD_TRANSFER_ACCOUNT_FAILURE';
export const UPDATE_TRANSFER_RESULT_SUCCESS = 'UPDATE_TRANSFER_RESULT_SUCCESS';
export const UPDATE_TRANSFER_RESULT_FAILURE = 'UPDATE_TRANSFER_RESULT_FAILURE';
export const CLEAR_UPLOAD_CSV_RESULT_FLG = 'CLEAR_UPLOAD_CSV_RESULT_FLG';
export const UPLOAD_CSV_TRANSACTION_STATUS_VERITRANS_SUCCESS = 'UPLOAD_CSV_TRANSACTION_STATUS_VERITRANS_SUCCESS';
export const UPLOAD_CSV_TRANSACTION_STATUS_VERITRANS_FAILURE = 'UPLOAD_CSV_TRANSACTION_STATUS_VERITRANS_FAILURE';

// CSV_PAYMENT
export const UPLOAD_CSV_PAYMENT_SUCCESS = 'UPLOAD_CSV_PAYMENT_SUCCESS';
export const UPLOAD_CSV_PAYMENT_FAILURE = 'UPLOAD_CSV_PAYMENT_FAILURE';
export const CLEAR_UPLOAD_CSV_PAYMENT_RESULT_FLG = 'CLEAR_UPLOAD_CSV_PAYMENT_RESULT_FLG';

export const SET_PROCESSING_QUERY = 'SET_PROCESSING_QUERY';

// customer
export const GET_CUSTOMER_LIST_SUCCESS = 'GET_CUSTOMER_LIST_SUCCESS';
export const GET_CUSTOMER_LIST_FAILURE = 'GET_CUSTOMER_LIST_FAILURE';
export const GET_ALL_CUSTOMER_LIST_SUCCESS = 'GET_ALL_CUSTOMER_LIST_SUCCESS';
export const GET_ALL_CUSTOMER_LIST_FAILURE = 'GET_ALL_CUSTOMER_LIST_FAILURE';
export const GET_CSV_CUSTOMER_LIST_SUCCESS = 'GET_CSV_CUSTOMER_LIST_SUCCESS';
export const GET_CSV_CUSTOMER_LIST_FAILURE = 'GET_CSV_CUSTOMER_LIST_FAILURE';

export const GET_CUSTOMER_DETAIL_SUCCESS = 'GET_CUSTOMER_DETAIL_SUCCESS';
export const GET_CUSTOMER_DETAIL_FAILURE = 'GET_CUSTOMER_DETAIL_FAILURE';
export const SET_CUSTOMER_SEARCH_PARAMS = 'SET_CUSTOMER_SEARCH_PARAMS';
export const CLEAR_CUSTOMER_SEARCH_PARAMS = 'CLEAR_CUSTOMER_SEARCH_PARAMS';

export const DELETE_CUSTOMER_SUCCESS = 'DELETE_CUSTOMER_SUCCESS';
export const DELETE_CUSTOMER_FAILURE = 'DELETE_CUSTOMER_FAILURE';
export const CLEAR_DELETE_CUSTOMER_RESULT_FLG = 'CLEAR_DELETE_CUSTOMER_RESULT_FLG';

export const SEND_MAIL_CUSTOMER_SUCCESS = 'SEND_MAIL_CUSTOMER_SUCCESS';
export const SEND_MAIL_CUSTOMER_FAILURE = 'SEND_MAIL_CUSTOMER_FAILURE';
export const CLEAR_SEND_MAIL_CUSTOMER_RESULT_FLG = 'CLEAR_SEND_MAIL_CUSTOMER_RESULT_FLG';

export const CREATE_CUSTOMER_BY_CSV_FAILURE = 'CREATE_CUSTOMER_BY_CSV_FAILURE';
export const CLEAR_CREATE_CUSTOMER_BY_CSV_RESULT = 'CLEAR_CREATE_CUSTOMER_BY_CSV_RESULT';

export const SET_CUSTOMER_QUERY = 'SET_CUSTOMER_QUERY';
export const CLEAR_CUSTOMER_QUERY = 'CLEAR_CUSTOMER_QUERY';

// product
export const GET_PRODUCT_LIST_SUCCESS = 'GET_PRODUCT_LIST_SUCCESS';
export const GET_PRODUCT_LIST_FAILURE = 'GET_PRODUCT_LIST_FAILURE';
export const GET_PRODUCT_DETAIL_SUCCESS = 'GET_PRODUCT_DETAIL_SUCCESS';
export const GET_PRODUCT_DETAIL_FAILURE = 'GET_PRODUCT_DETAIL_FAILURE';
export const DELETE_PRODUCT_SUCCESS = 'DELETE_PRODUCT_SUCCESS';
export const DELETE_PRODUCT_FAILURE = 'DELETE_PRODUCT_FAILURE';
export const CLEAR_DELETE_PRODUCT_RESULT_FLG = 'CLEAR_DELETE_PRODUCT_RESULT_FLG';

// product stock
export const GET_PRODUCT_STOCK_SUCCESS = 'GET_PRODUCT_STOCK_SUCCESS';
export const GET_PRODUCT_STOCK_FAILURE = 'GET_PRODUCT_STOCK_FAILURE';
export const GET_PRODUCT_STOCK_HISTORY_SUCCESS = 'GET_PRODUCT_STOCK_HISTORY_SUCCESS';
export const GET_PRODUCT_STOCK_HISTORY_FAILURE = 'GET_PRODUCT_STOCK_HISTORY_FAILURE';
export const CREATE_PRODUCT_STOCK_HISTORY_SUCCESS = 'CREATE_PRODUCT_STOCK_HISTORY_SUCCESS';
export const CREATE_PRODUCT_STOCK_HISTORY_FAILURE = 'CREATE_PRODUCT_STOCK_HISTORY_FAILURE';
export const GET_PRODUCT_STOCK_IN_WAREHOUSE_SUCCESS = 'GET_PRODUCT_STOCK_IN_WAREHOUSE_SUCCESS';
export const GET_PRODUCT_STOCK_IN_WAREHOUSE_FAILURE = 'GET_PRODUCT_STOCK_IN_WAREHOUSE_FAILURE';
export const GET_PRODUCT_EXPIRATION_SUCCESS = 'GET_PRODUCT_EXPIRATION_SUCCESS';
export const GET_PRODUCT_EXPIRATION_FAILURE = 'GET_PRODUCT_EXPIRATION_FAILURE';
export const CREATE_PRODUCT_EXPIRATION_SUCCESS = 'CREATE_PRODUCT_EXPIRATION_SUCCESS';
export const CREATE_PRODUCT_EXPIRATION_FAILURE = 'CREATE_PRODUCT_EXPIRATION_FAILURE';
export const UPDATE_PRODUCT_EXPIRATION_SUCCESS = 'UPDATE_PRODUCT_EXPIRATION_SUCCESS';
export const UPDATE_PRODUCT_EXPIRATION_FAILURE = 'UPDATE_PRODUCT_EXPIRATION_FAILURE';

// productCategory
export const GET_PRODUCT_CATEGORY_LIST_SUCCESS = 'GET_PRODUCT_CATEGORY_LIST_SUCCESS';
export const GET_PRODUCT_CATEGORY_LIST_FAILURE = 'GET_PRODUCT_CATEGORY_LIST_FAILURE';
export const GET_PRODUCT_CATEGORY_DETAIL_SUCCESS = 'GET_PRODUCT_CATEGORY_DETAIL_SUCCESS';
export const GET_PRODUCT_CATEGORY_DETAIL_FAILURE = 'GET_PRODUCT_CATEGORY_DETAIL_FAILURE';
export const DELETE_PRODUCT_CATEGORY_SUCCESS = 'DELETE_PRODUCT_CATEGORY_SUCCESS';
export const DELETE_PRODUCT_CATEGORY_FAILURE = 'DELETE_PRODUCT_CATEGORY_FAILURE';
export const CLEAR_DELETE_PRODUCT_CATEGORY_RESULT_FLG = 'CLEAR_DELETE_PRODUCT_CATEGORY_RESULT_FLG';

// product tag
export const GET_PRODUCT_TAG_LIST_SUCCESS = 'GET_PRODUCT_TAG_LIST_SUCCESS';
export const GET_PRODUCT_TAG_LIST_FAILURE = 'GET_PRODUCT_TAG_LIST_FAILURE';
export const GET_PRODUCT_TAG_DETAIL_SUCCESS = 'GET_PRODUCT_TAG_DETAIL_SUCCESS';
export const GET_PRODUCT_TAG_DETAIL_FAILURE = 'GET_PRODUCT_TAG_DETAIL_FAILURE';
export const DELETE_PRODUCT_TAG_SUCCESS = 'DELETE_PRODUCT_TAG_SUCCESS';
export const DELETE_PRODUCT_TAG_FAILURE = 'DELETE_PRODUCT_TAG_FAILURE';
export const CLEAR_DELETE_PRODUCT_TAG_RESULT_FLG = 'CLEAR_DELETE_PRODUCT_TAG_RESULT_FLG';

// salesPerson
export const GET_SALES_PERSON_LIST_SUCCESS = 'GET_SALES_PERSON_LIST_SUCCESS';
export const GET_SALES_PERSON_LIST_FAILURE = 'GET_SALES_PERSON_LIST_FAILURE';
export const GET_SALES_PERSON_DETAIL_SUCCESS = 'GET_SALES_PERSON_DETAIL_SUCCESS';
export const GET_SALES_PERSON_DETAIL_FAILURE = 'GET_SALES_PERSON_DETAIL_FAILURE';
export const SALESPERSON_SIGN_UP_SUCCESS = 'SALESPERSON_SIGN_UP_SUCCESS';
export const SALESPERSON_SIGN_UP_FAILURE = 'SALESPERSON_SIGN_UP_FAILURE';
export const DELETE_SALESPERSON_SUCCESS = 'DELETE_SALESPERSON_SUCCESS';
export const DELETE_SALESPERSON_FAILURE = 'DELETE_SALESPERSON_FAILURE';
export const CLEAR_DELETE_SALESPERSON_RESULT_FLG = 'CLEAR_DELETE_SALESPERSON_RESULT_FLG';
export const GET_CSV_SALES_PERSON_LIST_SUCCESS = 'GET_CSV_SALES_PERSON_LIST_SUCCESS';
export const GET_CSV_SALES_PERSON_LIST_FAILURE = 'GET_CSV_SALES_PERSON_LIST_FAILURE';

// agency
export const GET_AGENCY_LIST_SUCCESS = 'GET_AGENCY_LIST_SUCCESS';
export const GET_AGENCY_LIST_FAILURE = 'GET_AGENCY_LIST_FAILURE';

// paymentPage
export const GET_PAYMENT_PAGE_LIST_SUCCESS = 'GET_PAYMENT_PAGE_LIST_SUCCESS';
export const GET_PAYMENT_PAGE_LIST_FAILURE = 'GET_PAYMENT_PAGE_LIST_FAILURE';

// salesPerson
export const GET_COUPON_LIST_SUCCESS = 'GET_COUPON_LIST_SUCCESS';
export const GET_COUPON_LIST_FAILURE = 'GET_COUPON_LIST_FAILURE';
export const GET_COUPON_DETAIL_SUCCESS = 'GET_COUPON_DETAIL_SUCCESS';
export const GET_COUPON_DETAIL_FAILURE = 'GET_COUPON_DETAIL_FAILURE';

// prefecture
export const GET_PREF_LIST_SUCCESS = 'GET_PREF_LIST_SUCCESS';
export const GET_PREF_LIST_FAILURE = 'GET_PREF_LIST_FAILURE';

// pagination
export const SET_PAGINATE_COUNT = 'SET_PAGINATE_COUNT';
export const CLEAR_PAGINATE_COUNT = 'CLEAR_PAGINATE_COUNT';

// qrquery
export const CREATE_QRQUERY_SUCCESS = 'CREATE_QRQUERY_SUCCESS';
export const CREATE_QRQUERY_FAILURE = 'CREATE_QRQUERY_FAILURE';
export const CLEAR_QRQUERY_TOKEN = 'CLEAR_QRQUERY_TOKEN';

// invoice
export const GET_INVOICE_HISTORY_LIST_SUCCESS = 'GET_INVOICE_HISTORY_LIST_SUCCESS';
export const GET_INVOICE_HISTORY_LIST_FAILURE = 'GET_INVOICE_HISTORY_LIST_FAILURE';
export const SET_INVOICE_QUERY = 'SET_INVOICE_QUERY';
export const SET_INVIOCE_DETAIL = 'SET_INVIOCE_DETAIL';
export const GET_INVOICE_DRAFT_LIST_SUCCESS = 'GET_INVOICE_DRAFT_LIST_SUCCESS';
export const GET_INVOICE_DRAFT_LIST_FAILURE = 'GET_INVOICE_DRAFT_LIST_FAILURE';
export const GET_INVOICE_HISTORY_TRANSFER_LIST_SUCCESS = 'GET_INVOICE_HISTORY_TRANSFER_LIST_SUCCESS';
export const GET_INVOICE_HISTORY_TRANSFER_LIST_FAILURE = 'GET_INVOICE_HISTORY_TRANSFER_LIST_FAILURE';
export const DELETE_INVOICE_DRAFT_SUCCESS = 'DELETE_INVOICE_DRAFT_SUCCESS';
export const CLEAR_DELETE_INVOICE_DRAFT_RESULT = 'CLEAR_DELETE_INVOICE_DRAFT_RESULT';

//ruleGroup
export const GET_RULE_GROUP_LIST_SUCCESS = 'GET_RULE_GROUP_LIST_SUCCESS';
export const GET_RULE_GROUP_LIST_FAILURE = 'GET_RULE_GROUP_LIST_FAILURE';
export const GET_RULE_GROUP_DETAIL_SUCCESS = 'GET_RULE_GROUP_DETAIL_SUCCESS';
export const GET_RULE_GROUP_DETAIL_FAILURE = 'GET_RULE_GROUP_DETAIL_FAILURE';
export const SET_RULE_GROUP_QUERY = 'SET_RULE_GROUP_QUERY';

//rule
export const GET_RULE_DETAIL_SUCCESS = 'GET_RULE_DETAIL_SUCCESS';
export const GET_RULE_DETAIL_FAILURE = 'GET_RULE_DETAIL_FAILURE';
export const GET_RULE_LIST_BY_GROUP_SUCCESS = 'GET_RULE_LIST_BY_GROUP_SUCCESS';
export const GET_RULE_LIST_BY_GROUP_FAILURE = 'GET_RULE_LIST_BY_GROUP_FAILURE';
export const SET_RULE_QUERY = 'SET_RULE_QUERY';

//dashboard
export const GET_DATA_DASHBOARD_SUCCESS = 'GET_DATA_DASHBOARD_SUCCESS';
export const GET_DATA_DASHBOARD_FAILURE = 'GET_DATA_DASHBOARD_FAILURE';
export const GET_DATA_DASHBOARD_PRODUCTS_SUCCESS = 'GET_DATA_DASHBOARD_PRODUCTS_SUCCESS';
export const GET_DATA_DASHBOARD_PRODUCTS_FAILURE = 'GET_DATA_DASHBOARD_PRODUCTS_FAILURE';
export const GET_DATA_DASHBOARD_ORDER_SUCCESS = 'GET_DATA_DASHBOARD_ORDER_SUCCESS';
export const GET_DATA_DASHBOARD_ORDER_FAILURE = 'GET_DATA_DASHBOARD_ORDER_FAILURE';

//customerstatus
export const GET_ALL_CUSTOMER_STATUS_BY_COMPANY_SUCCESS = 'GET_ALL_CUSTOMER_STATUS_BY_COMPANY_SUCCESS';
export const GET_ALL_CUSTOMER_STATUS_BY_COMPANY_FAILURE = 'GET_ALL_CUSTOMER_STATUS_BY_COMPANY_FAILURE';

//news
export const GET_NEWS_LIST_SUCCESS = 'GET_NEWS_LIST_SUCCESS';
export const GET_NEWS_LIST_FAILURE = 'GET_NEWS_LIST_FAILURE';
export const GET_NEWS_DETAIL_SUCCESS = 'GET_NEWS_DETAIL_SUCCESS';
export const GET_NEWS_DETAIL_FAILURE = 'GET_NEWS_DETAIL_FAILURE';
export const SET_NEWS_QUERY = 'SET_NEWS_QUERY';
export const UPDATE_NEWS_SUCCESS = 'UPDATE_NEWS_SUCCESS';
export const DELETE_NEWS_SUCCESS = 'DELETE_NEWS_SUCCESS';
export const CLEAR_NEWS_RESULT = 'CLEAR_NEWS_RESULT';

// Delivery
export const GET_DELIVERY_LIST_SUCCESS = 'GET_DELIVERY_LIST_SUCCESS';
export const GET_DELIVERY_LIST_FAILURE = 'GET_DELIVERY_LIST_FAILURE';
export const GET_DELIVERY_DETAIL_SUCCESS = 'GET_DELIVERY_DETAIL_SUCCESS';
export const GET_DELIVERY_DETAIL_FAILURE = 'GET_DELIVERY_DETAIL_FAILURE';
export const SET_DELIVERY_QUERY = 'SET_DELIVERY_QUERY';
export const CLEAR_DELIVERY_QUERY = 'CLEAR_DELIVERY_QUERY';
export const UPLOAD_DELIVERY_CSV_SUCCESS = 'UPLOAD_DELIVERY_CSV_SUCCESS';
export const UPLOAD_DELIVERY_CSV_FAILURE = 'UPLOAD_DELIVERY_CSV_FAILURE';
export const CLEAR_DELIVERY_CSV = 'CLEAR_DELIVERY_CSV';

// Product Option
export const GET_PRODUCT_OPTION_LIST_SUCCESS = 'GET_PRODUCT_OPTION_LIST_SUCCESS';
export const GET_PRODUCT_OPTION_LIST_FAILURE = 'GET_PRODUCT_OPTION_LIST_FAILURE';
export const GET_PRODUCT_OPTION_DETAIL_SUCCESS = 'GET_PRODUCT_OPTION_DETAIL_SUCCESS';
export const GET_PRODUCT_OPTION_DETAIL_FAILURE = 'GET_PRODUCT_OPTION_DETAIL_FAILURE';
export const SET_PRODUCT_OPTION_QUERY = 'SET_PRODUCT_OPTION_QUERY';
export const CLEAR_PRODUCT_OPTION_QUERY = 'CLEAR_PRODUCT_OPTION_QUERY';
export const DELETE_PRODUCT_OPTION_SUCCESS = 'DELETE_PRODUCT_OPTION_SUCCESS';
export const DELETE_PRODUCT_OPTION_FAILURE = 'DELETE_PRODUCT_OPTION_FAILURE';
export const CLEAR_PRODUCT_OPTION_RESULT_FLG = 'CLEAR_PRODUCT_OPTION_RESULT_FLG';

// EC Information
export const GET_EC_INFORMATION_LIST_SUCCESS = 'GET_EC_INFORMATION_LIST_SUCCESS';
export const GET_EC_INFORMATION_LIST_FAILURE = 'GET_EC_INFORMATION_LIST_FAILURE';
export const GET_EC_INFORMATION_DETAIL_SUCCESS = 'GET_EC_INFORMATION_DETAIL_SUCCESS';
export const GET_EC_INFORMATION_DETAIL_FAILURE = 'GET_EC_INFORMATION_DETAIL_FAILURE';
export const CREATE_EC_INFORMATION_SUCCESS = 'CREATE_EC_INFORMATION_SUCCESS';
export const CREATE_EC_INFORMATION_FAILURE = 'CREATE_EC_INFORMATION_FAILURE';
export const UPDATE_EC_INFORMATION_SUCCESS = 'UPDATE_EC_INFORMATION_SUCCESS';
export const UPDATE_EC_INFORMATION_FAILURE = 'UPDATE_EC_INFORMATION_FAILURE';
export const DELETE_EC_INFORMATION_SUCCESS = 'DELETE_EC_INFORMATION_SUCCESS';
export const DELETE_EC_INFORMATION_FAILURE = 'DELETE_EC_INFORMATION_FAILURE';
export const CLEAR_DELETE_EC_INFORMATION_RESULT_FLG = 'CLEAR_DELETE_EC_INFORMATION_RESULT_FLG';

// EC Shopping Guide
export const GET_EC_SHOPPING_GUIDE_LIST_SUCCESS = 'GET_EC_SHOPPING_GUIDE_LIST_SUCCESS';
export const GET_EC_SHOPPING_GUIDE_LIST_FAILURE = 'GET_EC_SHOPPING_GUIDE_LIST_FAILURE';
export const GET_EC_SHOPPING_GUIDE_DETAIL_SUCCESS = 'GET_EC_SHOPPING_GUIDE_DETAIL_SUCCESS';
export const GET_EC_SHOPPING_GUIDE_DETAIL_FAILURE = 'GET_EC_SHOPPING_GUIDE_DETAIL_FAILURE';
export const CREATE_EC_SHOPPING_GUIDE_SUCCESS = 'CREATE_EC_SHOPPING_GUIDE_SUCCESS';
export const CREATE_EC_SHOPPING_GUIDE_FAILURE = 'CREATE_EC_SHOPPING_GUIDE_FAILURE';
export const UPDATE_EC_SHOPPING_GUIDE_SUCCESS = 'UPDATE_EC_SHOPPING_GUIDE_SUCCESS';
export const UPDATE_EC_SHOPPING_GUIDE_FAILURE = 'UPDATE_EC_SHOPPING_GUIDE_FAILURE';
export const DELETE_EC_SHOPPING_GUIDE_SUCCESS = 'DELETE_EC_SHOPPING_GUIDE_SUCCESS';
export const DELETE_EC_SHOPPING_GUIDE_FAILURE = 'DELETE_EC_SHOPPING_GUIDE_FAILURE';
export const CLEAR_DELETE_EC_SHOPPING_GUIDE_RESULT_FLG = 'CLEAR_DELETE_EC_SHOPPING_GUIDE_RESULT_FLG';

// EC Commercial Transaction Law
export const GET_EC_COMMERCIAL_TRANSACTION_LAW_LIST_SUCCESS = 'GET_EC_COMMERCIAL_TRANSACTION_LAW_LIST_SUCCESS';
export const GET_EC_COMMERCIAL_TRANSACTION_LAW_LIST_FAILURE = 'GET_EC_COMMERCIAL_TRANSACTION_LAW_LIST_FAILURE';
export const GET_EC_COMMERCIAL_TRANSACTION_LAW_DETAIL_SUCCESS = 'GET_EC_COMMERCIAL_TRANSACTION_LAW_DETAIL_SUCCESS';
export const GET_EC_COMMERCIAL_TRANSACTION_LAW_DETAIL_FAILURE = 'GET_EC_COMMERCIAL_TRANSACTION_LAW_DETAIL_FAILURE';
export const CREATE_EC_COMMERCIAL_TRANSACTION_LAW_SUCCESS = 'CREATE_EC_COMMERCIAL_TRANSACTION_LAW_SUCCESS';
export const CREATE_EC_COMMERCIAL_TRANSACTION_LAW_FAILURE = 'CREATE_EC_COMMERCIAL_TRANSACTION_LAW_FAILURE';
export const UPDATE_EC_COMMERCIAL_TRANSACTION_LAW_SUCCESS = 'UPDATE_EC_COMMERCIAL_TRANSACTION_LAW_SUCCESS';
export const UPDATE_EC_COMMERCIAL_TRANSACTION_LAW_FAILURE = 'UPDATE_EC_COMMERCIAL_TRANSACTION_LAW_FAILURE';
export const DELETE_EC_COMMERCIAL_TRANSACTION_LAW_SUCCESS = 'DELETE_EC_COMMERCIAL_TRANSACTION_LAW_SUCCESS';
export const DELETE_EC_COMMERCIAL_TRANSACTION_LAW_FAILURE = 'DELETE_EC_COMMERCIAL_TRANSACTION_LAW_FAILURE';
export const CLEAR_DELETE_EC_COMMERCIAL_TRANSACTION_LAW_RESULT_FLG = 'CLEAR_DELETE_EC_COMMERCIAL_TRANSACTION_LAW_RESULT_FLG';
// Company FAQ
export const GET_COMPANY_FAQ_LIST_SUCCESS = 'GET_COMPANY_FAQ_LIST_SUCCESS';
export const GET_COMPANY_FAQ_LIST_FAILURE = 'GET_COMPANY_FAQ_LIST_FAILURE';
export const GET_COMPANY_FAQ_DETAIL_SUCCESS = 'GET_COMPANY_FAQ_DETAIL_SUCCESS';
export const GET_COMPANY_FAQ_DETAIL_FAILURE = 'GET_COMPANY_FAQ_DETAIL_FAILURE';
export const CREATE_COMPANY_FAQ_SUCCESS = 'CREATE_COMPANY_FAQ_SUCCESS';
export const CREATE_COMPANY_FAQ_FAILURE = 'CREATE_COMPANY_FAQ_FAILURE';
export const UPDATE_COMPANY_FAQ_SUCCESS = 'UPDATE_COMPANY_FAQ_SUCCESS';
export const UPDATE_COMPANY_FAQ_FAILURE = 'UPDATE_COMPANY_FAQ_FAILURE';
export const DELETE_COMPANY_FAQ_SUCCESS = 'DELETE_COMPANY_FAQ_SUCCESS';
export const DELETE_COMPANY_FAQ_FAILURE = 'DELETE_COMPANY_FAQ_FAILURE';
export const CLEAR_DELETE_COMPANY_FAQ_RESULT_FLG = 'CLEAR_DELETE_COMPANY_FAQ_RESULT_FLG';
export const SET_COMPANY_FAQ_QUERY = 'SET_COMPANY_FAQ_QUERY';

// Warehouse
export const GET_WAREHOUSE_LIST_SUCCESS = 'GET_WAREHOUSE_LIST_SUCCESS';
export const GET_WAREHOUSE_LIST_FAILURE = 'GET_WAREHOUSE_LIST_FAILURE';
export const GET_WAREHOUSE_DETAILS_SUCCESS = 'GET_WAREHOUSE_DETAILS_SUCCESS';
export const GET_WAREHOUSE_DETAILS_FAILURE = 'GET_WAREHOUSE_DETAILS_FAILURE';
export const CREATE_WAREHOUSE_SUCCESS = 'CREATE_WAREHOUSE_SUCCESS';
export const CREATE_WAREHOUSE_FAILURE = 'CREATE_WAREHOUSE_FAILURE';
export const UPDATE_WAREHOUSE_SUCCESS = 'UPDATE_WAREHOUSE_SUCCESS';
export const UPDATE_WAREHOUSE_FAILURE = 'UPDATE_WAREHOUSE_FAILURE';
export const CLEAR_WAREHOUSE_RESULT_FLG = 'CLEAR_WAREHOUSE_RESULT_FLG';

// WholesalePrice
export const GET_WHOLESALE_PRICE_LIST_SUCCESS = 'GET_WHOLESALE_PRICE_LIST_SUCCESS';
export const GET_WHOLESALE_PRICE_LIST_FAILURE = 'GET_WHOLESALE_PRICE_LIST_FAILURE';
export const GET_WHOLESALE_PRICE_DETAILS_SUCCESS = 'GET_WHOLESALE_PRICE_DETAILS_SUCCESS';
export const GET_WHOLESALE_PRICE_DETAILS_FAILURE = 'GET_WHOLESALE_PRICE_DETAILS_FAILURE';
export const CREATE_WHOLESALE_PRICE_SUCCESS = 'CREATE_WHOLESALE_PRICE_SUCCESS';
export const CREATE_WHOLESALE_PRICE_FAILURE = 'CREATE_WHOLESALE_PRICE_FAILURE';
export const UPDATE_WHOLESALE_PRICE_SUCCESS = 'UPDATE_WHOLESALE_PRICE_SUCCESS';
export const UPDATE_WHOLESALE_PRICE_FAILURE = 'UPDATE_WHOLESALE_PRICE_FAILURE';
export const CLEAR_WHOLESALE_PRICE_RESULT_FLG = 'CLEAR_WHOLESALE_PRICE_RESULT_FLG';
export const GET_WHOLESALE_COMPANY_LIST_SUCCESS = 'GET_WHOLESALE_COMPANY_LIST_SUCCESS';
export const GET_WHOLESALE_COMPANY_LIST_FAILURE = 'GET_WHOLESALE_COMPANY_LIST_FAILURE';
export const CREATE_WHOLESALE_COMPANY_SUCCESS = 'CREATE_WHOLESALE_COMPANY_SUCCESS';
export const CREATE_WHOLESALE_COMPANY_FAILURE = 'CREATE_WHOLESALE_COMPANY_FAILURE';

// document DOCUMENT
export const GET_DOCUMENT_LIST_SUCCESS = 'GET_DOCUMENT_LIST_SUCCESS';
export const GET_DOCUMENT_LIST_FAILURE = 'GET_DOCUMENT_LIST_FAILURE';
export const SET_DOCUMENT_QUERY = 'SET_DOCUMENT_QUERY';
export const DOWNLOAD_FILE_SUCCESS = 'DOWNLOAD_FILE_SUCCESS';

// columns
export const GET_COLUMN_LIST_SUCCESS = 'GET_COLUMN_LIST_SUCCESS';
export const GET_COLUMN_LIST_FAILURE = 'GET_COLUMN_LIST_FAILURE';
export const GET_COLUMN_DETAIL_SUCCESS = 'GET_COLUMN_DETAIL_SUCCESS';
export const GET_COLUMN_DETAIL_FAILURE = 'GET_COLUMN_DETAIL_FAILURE';
export const UPDATE_COLUMN_SUCCESS = 'UPDATE_COLUMN_SUCCESS';
export const UPDATE_COLUMN_FAILURE = 'UPDATE_COLUMN_FAILURE';
